import React from "react";
import clsx from "clsx";

import { CircleUser, X } from "lucide-react";

export type AccountToggleProps = {
	isOpen: boolean;
	onClick: () => void;
};

/**
 * Header button that opens the account view of the mobile navigation. Renders
 * the user avatar when closed and a close (X) icon when the account view is the
 * active one, mirroring the burger's open/close affordance. Uses a distinct
 * aria-label from the desktop account dropdown ("Open account menu") to avoid
 * collisions in tests/accessibility queries.
 */
export const AccountToggle = ({ isOpen, onClick }: AccountToggleProps) => (
	<button
		type="button"
		onClick={onClick}
		data-testid="mobile-account-toggle"
		aria-controls="primary-mobile-nav"
		aria-expanded={isOpen}
		aria-label={isOpen ? "Close account navigation" : "Open account navigation"}
		className={clsx(
			"text-white flex cursor-pointer items-center stroke-current",
			"hover:bg-neutral-100/20 flex h-[40px] items-center rounded-md bg-transparent py-2 px-3 text-[24px]",
		)}
	>
		{isOpen ? <X className="size-6" /> : <CircleUser className="size-6" />}
	</button>
);
